import { setCommunitys,setCurrentCommunity,getCurrentCommunity } from "@/utils/vc"
import request from '@/utils/request'
export function _loadCommunityInfo(_param) {
    return new Promise((resolve, reject) => {
        request({
            url: '/community.listMyEnteredCommunitys',
            method: 'get',
            params: {
                page: 1,
                row: 100
            }
        }).then(response => {
            const res = response.data
            let _communityInfos = res.communitys;
            if (_communityInfos && _communityInfos.length > 0) {
                setCommunitys(_communityInfos);
                // 如果指定了 communityId，优先使用
                if (_param && _param.communityId) {
                    let _communityId = _param.communityId;
                    let _found = false;
                    _communityInfos.forEach(_c => {
                        if (_c.communityId == _communityId) {
                            setCurrentCommunity(_c);
                            _found = true;
                        }
                    })
                    if (!_found) {
                        setCurrentCommunity(_communityInfos[0]);
                    }
                } else {
                    // 没有指定 communityId 时，保留已有选中（Layout 刷新场景）
                    let _currentCommunity = JSON.parse(window.localStorage.getItem('hc_currentCommunityInfo'));
                    if (!_currentCommunity) {
                        setCurrentCommunity(_communityInfos[0]);
                    }
                }
            }
            // 获取验证码成功
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function getDict(tableName,tableColumns) {
    return new Promise((resolve, reject) => {
        request({
            url: '/callComponent/core/list',
            method: 'get',
            params: {
                name: tableName,
                type: tableColumns,
                page:1,
                row:500
            }
        }).then(response => {
            const res = response.data
            // 费用类型字典：按业务常用顺序排序
            if (tableName === 'pay_fee_config' && tableColumns === 'fee_type_cd' && Array.isArray(res)) {
                // 业务常用顺序：物业费、停车费、水费、电费、公摊费、押金、煤气费、取暖费、维修费、服务费、其他、租金...
                const orderMap = {
                    '888800010001': 1, // 物业费
                    '888800010008': 2, // 停车费
                    '888800010015': 3, // 水费
                    '888800010016': 4, // 电费
                    '888800010017': 5, // 公摊费
                    '888800010006': 6, // 押金
                    '888800010009': 7, // 煤气费
                    '888800010011': 8, // 取暖费
                    '888800010007': 9, // 维修费
                    '888800010010': 10, // 服务费
                    '888800010014': 11, // 其他
                    '888800010018': 12 // 租金
                }
                // 按 orderMap 排序（已知编码按指定顺序，未知编码保持原序追加到后面）
                const sorted = res.slice().sort((a, b) => {
                    const oa = orderMap[a.statusCd]
                    const ob = orderMap[b.statusCd]
                    if (oa != null && ob != null) return oa - ob
                    if (oa != null) return -1
                    if (ob != null) return 1
                    return 0
                })
                resolve(sorted)
                return
            }
            // 获取验证码成功
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function getCommunityId() {
    return getCurrentCommunity().communityId
}



export function getCommunity() {
    return getCurrentCommunity()
}



export function getCommunityName() {
    return getCurrentCommunity().name
}

export function getMyEnteredCommunitys(_param) {
    return new Promise((resolve, reject) => {
        request({
            url: '/community.listMyEnteredCommunitys',
            method: 'get',
            params: {
                ..._param
            }
        }).then(response => {
            const res = response.data
            // 获取验证码成功
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}